import { render, staticRenderFns } from "./WaterDropIcon.vue?vue&type=template&id=a652dc32"
import script from "./WaterDropIcon.vue?vue&type=script&lang=js"
export * from "./WaterDropIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports